export const LOCAL_PACK_LEADERBOARD_KEY = 'localPackLeaderboard';
